<template>
  <div class="streamlit-dashboard">
    <div v-if="loading">Loading...</div>
    <iframe
      v-else
      :src="streamlitUrl"
      frameborder="0"
      style="width: 100%; height: calc(100vh - 84px);"
      allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; microphone; midi; payment; usb; vr; xr-spatial-tracking"
      sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts allow-storage-access-by-user-activation"
      referrerpolicy="origin"
      loading="lazy"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'StreamlitDashboard',
  data() {
    return {
      streamlitUrl: 'https://google.com',
      loading: true // 添加 loading 状态
    }
  },
  created() {
    this.fetchStreamlitUrl()
  },
  methods: {
    fetchStreamlitUrl() {
      console.log('fetchStreamlitUrl')
      this.$axios.get('/config/streamlit-url', {params: {}})
        .then(response => {
          if (response.data) {
            this.streamlitUrl = response.data
          }
        })
        .catch(error => {
          console.error('Failed to fetch Streamlit URL:', error)
        })
        .finally(() => {
          this.loading = false // 无论成功失败都关闭 loading
        })
    }
  }
}
</script>

<style scoped>
.streamlit-dashboard {
  width: 100%;
  height: 100%;
  background: #fff;
}
</style> 